import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { CSSProperties, memo, ReactNode } from 'react';

import Loader from './loader';

const useStyles = makeStyles((theme: Theme) => ({
  loader: {
    ...theme.styles.center
  }
}));

interface Props {
  children: ReactNode;
  loading: boolean;
  height?: CSSProperties['height'];
  size?: number;
  color?: CSSProperties['color'];
}

const WithLoader = ({ loading, children, height = '100%', size = 40, color }: Props) => {
  const classes = useStyles();
  return (
    <>
      {loading ? (
        <Box height={height} className={classes.loader}>
          <Loader size={size} color={color} />
        </Box>
      ) : (
        children
      )}
    </>
  );
};

export default memo(WithLoader);
